import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '~/contexts/AuthContext';

// Client-side auth guard. The Netlify edge gate already prevents an
// unauthenticated browser from fetching the protected app chunk; this is the
// in-app belt-and-suspenders that bounces a session-less user to /login
// before any protected route renders.
export default function RequireAuth() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex h-screen items-center justify-center text-gray-400">Loading…</div>;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
